import { Pipe, PipeTransform } from '@angular/core';
import { ActionTypes } from 'src/app/models/api/playbooks/actions/actionTypes.enum';
import {
  PowerplatformAgentActionAuthenticationMode,
  PowerplatformAgentActionConfirmationMode,
  PowerplatformAgentActionSetAuthenticationModePayload,
  PowerplatformAgentActionSetConfirmationModePayload,
} from 'src/app/services/httpServices/actionsHttpService/actions-http-service.service';
import { PlaybookActionDefinitionPropertiesBase } from 'src/app/models/api/playbooks/playbook.model';

@Pipe({
  name: 'authConfModeNaming',
  standalone: true,
})
export class AuthenticationAndConfirmationModeNamingPipe implements PipeTransform {
  transform(actionType: ActionTypes, actionDefinitionProperties: PlaybookActionDefinitionPropertiesBase): ActionTypes {
    switch (actionType) {
      case ActionTypes.setAgentActionAuthenticationMode:
        return (actionDefinitionProperties as PowerplatformAgentActionSetAuthenticationModePayload)
          .authenticationMode === PowerplatformAgentActionAuthenticationMode.invoker
          ? ActionTypes.setUserContext
          : ActionTypes.setAuthorContext;
      case ActionTypes.setAgentActionConfirmationMode:
        return (actionDefinitionProperties as PowerplatformAgentActionSetConfirmationModePayload).confirmationMode ===
          PowerplatformAgentActionConfirmationMode.strict
          ? ActionTypes.setStrictMode
          : ActionTypes.setDisabledMode;
      default:
        return actionType;
    }
  }
}
